import Vuex from 'vuex';
import Vue from 'vue';
import user from './user';
import createPersistedState from 'vuex-persistedstate';
import {
  MAX_GENERAT_LEN
} from '@/global/index';
import {
  generateTask
} from '@/api/main';
import { GetQueryString } from "@/utils";
import jsCookie from "js-cookie";
import { submitTrackUtil, submitCompleteTrackUtil } from "@/utils/track";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user
  },
  state: {
    userInfo: {},
    tasks: [],
    imgTasks: [],
    full: '0',
    petId: '',
    recommend: '',
    image: '',
    delayTask: {},
    isMiniapp:false,
    tokens:{},
    remainCount:0,
    payStatus:1
  },
  mutations: {
    setIsMiniapp(state, isMiniapp) {
      state.isMiniapp = isMiniapp
    },
    setRemainCount(state, remainCount) {
      state.remainCount = remainCount;
    },
    setPayStatus(state, payStatus) {
      state.payStatus = payStatus;
    },
    setTasks(state, tasks) {
      state.tasks.push(tasks);
    },
    setDelayTask(state, tasks) {
      state.delayTask = tasks;
    },
    setTokens(state, tokens) {
      state.tokens = tokens;
    },
    setImage(state, image) {
      state.image = image;
    },
    setImgTasks(state, tasks) {
      state.imgTasks.push(tasks);
    },
    setFullScreen(state, full) {
      state.full = full;
    },
    setImgTasksv2(state, tasks) {
      state.imgTasks = tasks;
    },
    setTasksv2(state, tasks) {
      state.tasks = tasks;
    },
    setRiskToken(state, risk_token) {
      state.risk_token = risk_token;
    },

  },
  actions: {
    async _generateTask({
      state,
      commit
    }, payload) {
      if (state.tasks.length >= MAX_GENERAT_LEN) {
        Vue.prototype.$dialog.alert({
          title: "温馨提示",
          message: "上次任务还未完成，可到[创作记录]查看进度",
          confirmButtonColor: "#038DF9",
          showConfirmButton: false,
        });
        setTimeout(() => {
          Vue.prototype.$dialog.close();
        }, 1500);
        return;
      }
      commit("setTasks", {
        video: '',
        sub_task_id: '',
        task_completion: '',
        task_status: '',
        showTools: false
      })
      try {
        // TODO 上报submit事件
        const vuid = GetQueryString("vuid") ? GetQueryString("vuid") : jsCookie.get('vuid');
        submitTrackUtil(vuid, payload.task_id, payload.image);
        // console.log("log start!");

          // Ensure we have a risk token: if not present, try to fetch from SDK
          if (!state.risk_token) {
            try {
              if (Vue && Vue.prototype && Vue.prototype.$riskControl && Vue.prototype.$riskControl.getToken) {
                const tokenRes = await Vue.prototype.$riskControl.getToken();
                const fetchedRiskToken = tokenRes?.token || null;
                commit('setRiskToken', fetchedRiskToken);
                console.log('Fetched risk token from SDK:', fetchedRiskToken);
              }
            } catch (e) {
              console.warn('getRiskToken failed', e);
            }
          }

          const risk_token = typeof state.risk_token === 'string'
            ? state.risk_token
            : (state.risk_token?.risk_token ||  null);

        console.log("gen video begain payload.task_id = " + payload.task_id + ", payload.image = " + payload.image + ", risk_token = " + risk_token);

        let res = await generateTask({
          image: payload.image,
          task_id: payload.task_id,
          risk_token: risk_token,
        });
        // console.log(res.code);
        console.log("gen video payload.task_id = " + payload.task_id + ", payload.image = " + payload.image + ", risk_token = " + risk_token);
        //console.log("payload.image = " + payload.image);
        // console.log(res.data.sub_task_results[0].video);
        // console.log(res.data.history_id);

        if (res.code === 200) {
          commit('setImage', payload.image);
          commit("setDelayTask", {
            id: res.data.history_id,
            video: res.data.sub_task_results[0].video,
            sub_task_id: res.data.sub_task_results[0].sub_task_id,
            task_completion: 1,
            task_status: 1,
            showTools: false
          });

          // TODO 上报complete事件
          // console.log("submitCompleteTrack is not done.");
          submitCompleteTrackUtil(vuid, payload.task_id, payload.image, '', res.data.sub_task_results[0].video);
          //console.log("submitCompleteTrack is done.");
        }
      } catch (error) {
        console.log(error);
        state.tasks=[]
      }

    },
  },
  plugins: [createPersistedState({
    storage: window.localStorage,
    key: 'tasks'
  })]
});

export default store;